(() => {
  'use strict';
  const form = document.querySelector('[data-ry-component-form]');
  if (!form) return;
  const controls = [...form.querySelectorAll('[data-ry-refine]')];
  form.addEventListener('submit', event => {
    event.preventDefault();
    const tags = controls.map(control => control.value).filter(Boolean);
    const url = new URL(form.dataset.base + (tags.length ? '/' + tags.join('+') : ''), location.origin);
    const current = new URL(location.href);
    current.searchParams.forEach((value,key) => {
      if ((key.startsWith('filter.') && key !== 'filter.p.m.custom.compatible_model' && key !== 'filter.p.m.custom.bike_platform') || key === 'sort_by') url.searchParams.append(key,value);
    });
    if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id',window.Shopify.theme.id);
    location.assign(url.pathname + url.search);
  });
})();
